export default "__VITE_ASSET__DgwcTHmK__"